module.exports = __webpack_public_path__ + "img/10_reduced_inequalities.c310a8e7.svg";